import { z } from "zod";
import { Id } from "./ids.js";

/** What can be rated: a line of the bot's LESSONS.md, or a how-to skill. */
export const KNOWLEDGE_KINDS = ["lesson", "skill"] as const;
export const KnowledgeKindSchema = z.enum(KNOWLEDGE_KINDS);
export type KnowledgeKind = z.infer<typeof KnowledgeKindSchema>;

export const KnowledgeRatingValueSchema = z.enum(["useful", "not_useful"]);
export type KnowledgeRatingValue = z.infer<typeof KnowledgeRatingValueSchema>;

const counts = {
  useful: z.number().int().nonnegative(),
  notUseful: z.number().int().nonnegative(),
  /** The caller's own rating, if any. */
  mine: KnowledgeRatingValueSchema.nullable(),
};

/** A bot's lessons with their ratings, and the ratings of the skills it has. */
export const KnowledgeRatingsViewSchema = z.object({
  lessons: z.array(z.object({ key: z.string(), text: z.string(), ...counts })),
  skills: z.array(z.object({ key: Id, ...counts })),
});
export type KnowledgeRatingsView = z.infer<typeof KnowledgeRatingsViewSchema>;

export const RateKnowledgeInputSchema = z.object({
  botId: Id,
  kind: KnowledgeKindSchema,
  key: z.string().min(1).max(200),
  /** Null clears the caller's rating. */
  rating: KnowledgeRatingValueSchema.nullable(),
});
export type RateKnowledgeInput = z.infer<typeof RateKnowledgeInputSchema>;
